import { useCallback } from "react";
import {
  DimensionDictionary,
  QueryLoggingItem,
  ReportField,
  ValueCell,
} from "../../../../../shared/reporting/api/biClient.types";
import { generateGuid } from "../../../../../shared/utilities/generateGuid";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import {
  createCurrentReportAction,
  createDevToolsAction,
  createDrillDownPageAction,
  createMetaDataAction,
} from "../../../../store/utils/storeUtils";

const useCommonReportHandlers = () => {
  const dispatch = useAppDispatch();

  const setEtag = useCallback(
    (etag: string | undefined, cacheValid: boolean | undefined) => {
      dispatch(createCurrentReportAction("setEtag", { etag, cacheValid }));
    },
    [dispatch]
  );

  const onDrillDown = useCallback(
    (field: ReportField, cell: ValueCell) => {
      dispatch(
        createDrillDownPageAction("add", {
          id: generateGuid(),
          measure: field,
          cell,
          onlyLedger: false,
          chartOfAccounts: true,
        })
      );
    },
    [dispatch]
  );

  const updateDevTools = useCallback(
    (loggingItems: QueryLoggingItem[] | undefined) => {
      dispatch(createDevToolsAction("update", { loggingItems }));
    },
    [dispatch]
  );

  const onLoadDictionaries = useCallback(
    (result: Record<string, DimensionDictionary>[]) => {
      dispatch(createMetaDataAction("updateDictionaries", result));
    },
    [dispatch]
  );

  return {
    setEtag,
    updateDevTools,
    onLoadDictionaries,
    onDrillDown,
  };
};

export default useCommonReportHandlers;
